(function () {
  window.__STOCK_BADGE_VERSION = "v5-market-independent-target-product-url-variant";

  function onReady(fn){
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  // =========================
  // CONFIG
  // =========================

var TARGET_HANDLES = [
  "littlebig-convertible-balance-bike",
  "vee-tyre-upgrade"
];
  var LOW_STOCK_THRESHOLD = 1;

  // Optional text outside the preorder badge
  var PREORDER_NOTE = "";

  // Badge text
  var TEXT_IN_STOCK = "In Stock";
  var TEXT_LOW_STOCK = "Low stock";
  var TEXT_PREORDER = "Pre Order, expected dispatch Nov 2026";
  var TEXT_SOLD_OUT = "Sold Out";

  // Hide on virtual/gift card products
  var HIDE_GIFT_CARDS = true;

  // Keep this false for your setup, because some Shopify Markets/catalogs
  // can report inventory tracking differently.
  var HIDE_NON_TRACKED = false;

  var PRICE_SELECTORS = [
    ".product-price__current-price",
    ".product-price__cost",
    ".product-price__content",
    ".product-price",
    ".product__price .money",
    ".product__price [data-money]",
    "[data-product-price] .money",
    "[data-product-price]",
    ".product__price",
    ".product-price__current",
    ".price__current",
    ".price .money",
    ".price"
  ];

  // =========================
  // BASIC HELPERS
  // =========================

  function root(){
    var f = document.querySelector('form[action^="/cart/add"]');
    return (f && f.closest('[id^="shopify-section"]')) || document;
  }

  function form(r){
    return r.querySelector('form[action^="/cart/add"]');
  }

  function handleFromUrl(){
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : "";
  }

  function readInlineStock(){
    var el = document.getElementById("StockBadgeData");
    if (!el) return null;

    try {
      return JSON.parse(el.textContent || el.innerHTML);
    } catch(e) {
      return null;
    }
  }

  function getProductData(){
    var inline = readInlineStock();

    if (!inline) {
      return {
        handle: handleFromUrl(),
        gift_card: false,
        variants: []
      };
    }

    return {
      handle: inline.handle || handleFromUrl(),
      gift_card: !!inline.gift_card,
      variants: inline.variants || []
    };
  }

  function currentVariant(r, product){
    if (!product || !product.variants || !product.variants.length) {
      return null;
    }

    function findVariantById(id){
      if (!id) return null;

      for (var i = 0; i < product.variants.length; i++) {
        if (String(product.variants[i].id) === String(id)) {
          return product.variants[i];
        }
      }

      return null;
    }

    // 1 - Aurora updates the URL correctly, so this is the most reliable source.
    var urlVariant = new URLSearchParams(window.location.search).get("variant");
    var fromUrl = findVariantById(urlVariant);

    if (fromUrl) return fromUrl;

    // 2 - Main product form input.
    var mainInput = document.querySelector('input[name="id"][id^="product-form-"]');
    var fromMainInput = mainInput ? findVariantById(mainInput.value) : null;

    if (fromMainInput) return fromMainInput;

    // 3 - Scoped product form fallback.
    var f = form(r);

    var idEl = f && (
      f.querySelector('input[name="id"]') ||
      f.querySelector('select[name="id"]')
    );

    var fromScopedForm = idEl ? findVariantById(idEl.value) : null;

    if (fromScopedForm) return fromScopedForm;

    // 4 - Any matching ID input fallback.
    var allInputs = document.querySelectorAll('[name="id"]');

    for (var j = 0; j < allInputs.length; j++) {
      var fromAnyInput = findVariantById(allInputs[j].value);

      if (fromAnyInput) return fromAnyInput;
    }

    return product.variants[0];
  }

  function isTargetProduct(product){
    var h = ((product && product.handle) || handleFromUrl() || "").toLowerCase();
    return TARGET_HANDLES.indexOf(h) !== -1;
  }

  function shouldHideBadge(product, variant){
    if (HIDE_GIFT_CARDS && product && product.gift_card) return true;

    if (
      HIDE_NON_TRACKED &&
      variant &&
      (
        variant.inventory_management == null ||
        variant.inventory_management === ""
      )
    ) {
      return true;
    }

    return false;
  }

  // =========================
  // BADGE STATE LOGIC
  // =========================

  function stateFor(product, variant){
    if (!variant) return null;

    var qty =
      typeof variant.inventory_quantity === "number"
        ? variant.inventory_quantity
        : null;

    var policy = variant.inventory_policy || null;

    var available = !!variant.available;

    // TARGET PRODUCT:
    // For LittleBig bike, ignore Shopify Markets "available".
    // Use only inventory_quantity + inventory_policy.
    if (isTargetProduct(product)) {

      if (qty !== null) {

        if (qty <= 0) {

          if (policy === "continue") {
            return {
              cls: "preorder",
              text: TEXT_PREORDER,
              note: PREORDER_NOTE
            };
          }

          return {
            cls: "out",
            text: TEXT_SOLD_OUT,
            note: null
          };
        }

        if (qty <= LOW_STOCK_THRESHOLD) {
          return {
            cls: "low",
            text: TEXT_LOW_STOCK,
            note: null
          };
        }

        return {
          cls: "in",
          text: TEXT_IN_STOCK,
          note: null
        };
      }

      // If quantity is missing on the target product, do not trust market-specific available.
      // Safer fallback:
      if (policy === "continue") {
        return {
          cls: "preorder",
          text: TEXT_PREORDER,
          note: PREORDER_NOTE
        };
      }

      return {
        cls: "out",
        text: TEXT_SOLD_OUT,
        note: null
      };
    }

    // NON-TARGET PRODUCTS:
    // Normal inventory logic.
    if (qty !== null) {
      if (qty > 0) {
        if (qty <= LOW_STOCK_THRESHOLD) {
          return {
            cls: "low",
            text: TEXT_LOW_STOCK,
            note: null
          };
        }

        return {
          cls: "in",
          text: TEXT_IN_STOCK,
          note: null
        };
      }

      return {
        cls: "out",
        text: TEXT_SOLD_OUT,
        note: null
      };
    }

    return available
      ? {
          cls: "in",
          text: TEXT_IN_STOCK,
          note: null
        }
      : {
          cls: "out",
          text: TEXT_SOLD_OUT,
          note: null
        };
  }

  // =========================
  // DOM / BADGE RENDERING
  // =========================

  function findPriceAnchor(r){
    for (var i = 0; i < PRICE_SELECTORS.length; i++) {
      var el = r.querySelector(PRICE_SELECTORS[i]);
      if (el) return el;
    }

    return null;
  }

  function ensureBadge(anchor){
    var parent = anchor.parentNode || anchor;

    if (parent.classList) {
      parent.classList.add("price-and-stock--inline");
    }

    var badge = parent.querySelector("[data-stock-badge]");

    if (!badge) {
      badge = document.createElement("span");
      badge.setAttribute("data-stock-badge", "");

      if (anchor.nextSibling) {
        parent.insertBefore(badge, anchor.nextSibling);
      } else {
        parent.appendChild(badge);
      }
    }

    return badge;
  }

  function removeBadge(r){
    var anchor = findPriceAnchor(r);
    if (!anchor) return;

    var parent = anchor.parentNode || anchor;

    var badge = parent.querySelector("[data-stock-badge]");
    if (badge) badge.remove();

    var oldNote = parent.querySelector(".price-preorder-note");
    if (oldNote) oldNote.remove();
  }

  function setNote(badge, text){
    var parent = badge && badge.parentNode;
    if (!parent) return;

    var old = parent.querySelector(".price-preorder-note");
    if (old) old.remove();

    if (!text) return;

    var note = document.createElement("span");
    note.className = "price-preorder-note";
    note.textContent = text;
    parent.insertBefore(note, badge.nextSibling);
  }

  function paint(r, product, variant){
    if (shouldHideBadge(product, variant)) {
      removeBadge(r);
      return;
    }

    var anchor = findPriceAnchor(r);
    if (!anchor) return;

    var state = stateFor(product, variant);
    if (!state) return;

    var badge = ensureBadge(anchor);

    badge.className = "price-badge price-badge--" + state.cls;
    badge.textContent = state.text;

    setNote(badge, state.note);
  }

  function repaint(r, product){
    var variant = currentVariant(r, product);
    r.__lastVariant = variant;
    paint(r, product, variant);
  }

  // =========================
  // OBSERVERS / EVENTS
  // =========================

  function scheduleRepaint(r, product, delay){
    setTimeout(function(){
      repaint(r, product);
    }, delay || 0);
  }

  function bindVariantEvents(r, product){
    document.addEventListener("variant:change", function(){
      scheduleRepaint(r, product, 0);
      scheduleRepaint(r, product, 100);
      scheduleRepaint(r, product, 250);
    });

    document.addEventListener("variant:changed", function(){
      scheduleRepaint(r, product, 0);
      scheduleRepaint(r, product, 100);
      scheduleRepaint(r, product, 250);
    });

    var f = form(r);
    if (f) {
      f.addEventListener("change", function(){
        scheduleRepaint(r, product, 0);
        scheduleRepaint(r, product, 100);
        scheduleRepaint(r, product, 250);
      }, { passive: true });
    }
  }

  function bindDomObserver(r, product){
    var mo = new MutationObserver(function(){
      clearTimeout(r.__stockBadgeTimer);
      r.__stockBadgeTimer = setTimeout(function(){
        repaint(r, product);
      }, 50);
    });

    mo.observe(r, {
      childList: true,
      subtree: true
    });

    r.__stockBadgeObserver = mo;
  }

  // =========================
  // INIT
  // =========================

  function init(){
    var r = root();
    if (!r) return;

    var product = getProductData();

    if (!product || !product.variants.length) return;

    repaint(r, product);

    bindVariantEvents(r, product);

    bindDomObserver(r, product);

    window.__stockBadgeDiag = {
      version: function(){
        return window.__STOCK_BADGE_VERSION;
      },
      classifyNow: function(){
        var rr = root();
        var pp = getProductData();
        var vv = currentVariant(rr, pp);

        return {
          handle: pp && pp.handle,
          gift_card: pp && pp.gift_card,
          variantId: vv && vv.id,
          qty: vv && vv.inventory_quantity,
          policy: vv && vv.inventory_policy,
          available: vv && vv.available,
          inventory_management: vv && vv.inventory_management,
          isTargetProduct: pp ? isTargetProduct(pp) : null,
          state: pp && vv ? stateFor(pp, vv) : null,
          priceAnchorFound: !!findPriceAnchor(rr),
          stockBadgeDataFound: !!document.getElementById("StockBadgeData"),
          urlVariant: new URLSearchParams(window.location.search).get("variant")
        };
      }
    };
  }

  onReady(init);
})();